module.exports = __webpack_public_path__ + "static/media/figure-drawing.49bf00ac.png";